<template lang="html">
    <div class="guarantee-detail">
        <MyTitle theTitle="担保详情"/>
        <div class="fd-com-scroll" ref="content">
            <PerviewBasic/>
            <PreviewSQR/>
            <PreviewBSQR/>
            <PreviewYGDLR/>
            <PreviewCCXS/>
            <PreviewSCCL/>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'
    import PerviewBasic from './previewGuarantee/previewBasic'
    import PreviewSQR from './previewGuarantee/previewSQR'
    import PreviewBSQR from './previewGuarantee/previewBSQR'
    import PreviewCCXS from './previewGuarantee/previewCCXS'
    import PreviewYGDLR from './previewGuarantee/previewYGDLR'
    import PreviewSCCL from './previewGuarantee/previewSCCL'

    export default {
        data() {
            return {
                active: 0,
                title: "和好",
                // 担保id
                dbid: this.$route.query.id
            }
        },
        // 依赖
        provide() {
            return {
                // 担保id
                dbid: this.dbid
            }
        },
        components: {
            MyTitle,
            PerviewBasic,
            PreviewSQR,
            PreviewBSQR,
            PreviewCCXS,
            PreviewYGDLR,
            PreviewSCCL
        },
        methods: {
            //点击导航
            changeNav(navIndex) {
                this.active = navIndex;
            },
        },
        mounted() {

        }
    }
</script>

<style lang="less" scoped>
    .guarantee-detail {

        .fd-nav {
            width: 100%;
            box-sizing: border-box;
            padding: 0 12px;
            display: flex;
            justify-content: space-between;
            line-height: 40px;
            background: #ffff;

            > span {
                font-size: 14px;
                color: #666666;
            }

            .span-active {
                color: #0683fc;
                cursor: pointer;
            }
        }

        .fd-case-info {
            width: 94%;
            margin-left: 3%;
            overflow: hidden;
            background: #fff;
            border-radius: 6px;
        }
    }
</style>
